import { authApi } from './index';
import { get as getCookie } from '../../utils/Cookie';
import axios from 'axios';

export const getBirthdayFaceUsers = async (isBirthday) => {
	try {
		const collectionName = getCookie('collectionName');
		let url = `/portal/collection/name/face-users?collectionName=${collectionName}`;
		if (isBirthday) {
			url = `/portal/collection/birth/face-users?collectionName=${collectionName}`;
		}
		let { data } = await authApi.get(url);
		console.log('getBirthdayFaceUsers data', data);

		let filteredData = data.filter((item) => {
			if (item?.type !== 'ACTIVATE') return false;
			return true;
		});

		for await (let child of filteredData) {
			const childFaceData = await getFaces(
				child.id,
				child.collections[0]?.name,
			);
			child.faces = childFaceData;
			if (child.faces[0]?.path) {
				const imgFile = await convertKidImageUrlToFile(child.faces[0]?.path);
				child.faceImages = URL.createObjectURL(imgFile);
			}
		}

		if (isBirthday) {
			const curMonth = new Date().getMonth() + 1;
			filteredData = filteredData.filter((item) => {
				const curBirth = item.birth.toString();
				const itemMonth = +curBirth?.slice(4, 6);
				return curMonth == itemMonth;
			});
		}
		console.log('getBirthdayFaceUsers', filteredData);
		return filteredData;
	} catch (error) {
		console.error(error);
		return null;
	}
};

export const getFaces = async (_faceUserId, _collectionName) => {
	try {
		const url = `/portal/collection/faces?faceUserId=${_faceUserId}&collectionName=${_collectionName}`;
		let { data } = await authApi.get(url);
		return data;
	} catch (error) {
		console.error(error);
	}
};

/**
 * 이미지 보내고 얼굴인식정보 받아오는 함수
 * @param {object} file - 파일 형태의 이미지
 * @returns {json} response - 객체 형태의 얼굴인식정보
 */
export const faceDetection = async (file) => {
	let URL = '/portal/face/detect';

	/* 서버로 파일(이미지 포함)을 전송하기 위해 FormData에 추가 */
	const formData = new FormData();
	/* 'file'은 서버에서 해당 파일을 식별하는 키이다. */
	formData.append('file', file);

	try {
		const response = await authApi.post(URL, formData);
		return response;
	} catch (error) {
		console.error(error);
	}
};

/**
 * 자른 얼굴 이미지 파일 업로드
 * @param {string} url
 * @param {string} serial
 * @returns
 */
export const croppedFaceFileUpload = async (url, serial) => {
	let stringSerial = serial.toString();
	let topic = `http://api.likuwithme.com/liku/contents/metaverse/liku/${stringSerial}/photos`;
	const formData = new FormData();
	formData.append('file', url);

	try {
		const response = await authApi.post(topic, formData, {
			// headers: { Authorization: `Bearer ${masterToken}` },
			headers: { Authorization: `Bearer ${getCookie('token')}` },
		});
	} catch (error) {
		console.error('uploadedFileError', error);
	}
};

/**
 * 얼굴 부분 자르기와 자른 얼굴 회전 처리
 * @param {string} tempURL - 리소스 가르키는 url
 * @param {Array} cropDataList - 얼굴 별 위치와 회전 각도 정보 리스트
 * @returns
 */
export const editImage = async (tempURL, cropDataList) => {
	return new Promise((resolve, reject) => {
		try {
			const image = new Image();
			image.src = tempURL;
			image.onload = async function () {
				const resizeScale = Math.min(
					1,
					2000 / Math.max(image.naturalWidth, image.naturalHeight),
				);
				let cropSource = image;
				if (resizeScale < 1) {
					const resizedCanvas = document.createElement('canvas');
					resizedCanvas.width = Math.max(
						1,
						Math.round(image.naturalWidth * resizeScale),
					);
					resizedCanvas.height = Math.max(
						1,
						Math.round(image.naturalHeight * resizeScale),
					);
					resizedCanvas
						.getContext('2d')
						.drawImage(image, 0, 0, resizedCanvas.width, resizedCanvas.height);
					cropSource = resizedCanvas;
				}

				const canvas = document.createElement('canvas');
				const context = canvas.getContext('2d');

				const ix = cropDataList.BoundingBox.Left;
				const iy = cropDataList.BoundingBox.Top;
				const iw = cropDataList.BoundingBox.Width;
				const ih = cropDataList.BoundingBox.Height;
				canvas.width = iw;
				canvas.height = ih;
				console.log('crop debug', {
					imageWidth: image.width,
					imageHeight: image.height,
					resizeScale,
					resizedWidth: cropSource.width,
					resizedHeight: cropSource.height,
					boundingBox: { ...cropDataList.BoundingBox },
					iw,
					ih,
					canvasWidth: canvas.width,
					canvasHeight: canvas.height,
				});

				let typeList = ['nose', 'rightEyeLeft', 'leftEyeRight'];
				let landmarkList = [];

				await cropDataList.Landmarks.map((value) => {
					if (typeList.includes(value.Type)) {
						let copy = { ...value };
						copy.x *= iw;
						copy.y *= ih;
						landmarkList.push(copy);
					}
				});

				for (let i = 0; i < landmarkList.length; i++) {
					if (landmarkList[i].Type === 'nose') {
						context.fillStyle = '#2B1C14';
						context.fillRect(0, 0, iw, ih);
						context.translate(iw / 2, ih / 2);
						context.rotate((-cropDataList.Pose.Roll * Math.PI) / 180);
						context.translate(-iw / 2, -ih / 2);
						context.globalAlpha = 0.9;
						context.fill();
						context.drawImage(cropSource, ix, iy, iw, ih, 0, 0, iw, ih);
					}
				}

				// ✅ 수정된 부분: Blob 반환
				canvas.toBlob((blob) => {
					URL.revokeObjectURL(tempURL); // 사용 후 정리
					if (blob) {
						resolve(blob);
					} else {
						reject(new Error('Blob 변환 실패'));
					}
				}, 'image/png');
			};
		} catch (error) {
			reject(error);
		}
	});
};

export const convertKidImageUrlToFile = async (_url) => {
	try {
		const addedSrc =
			'https://torooc-storage-fastapi.s3.ap-northeast-2.amazonaws.com/' + _url;
		const srcRegex =
			/^(?!.*https:\/\/)(?!.*http:\/\/)(?!.*static\/)(?!.*base64).*/;
		const finalUrl = srcRegex.test(_url) ? addedSrc : _url;
		const { data: imageData } = await axios({
			url: finalUrl,
			method: 'GET',
			responseType: 'blob',
			withCredentials: false,
		});

		const file = new File([imageData], 'faceImage.png', {
			type: 'image/png',
		});

		const faceDetectionData = await faceDetection(file);
		// console.log('getBirthday faceDetectionData', faceDetectionData);
		const YAW_limit = 25;
		const PITCH_limit = 20;
		let biggestFaceSize =
			faceDetectionData.data[0].BoundingBox.Width *
			faceDetectionData.data[0].BoundingBox.Height;
		let tempImageIdx = 0;
		let isLimit = false;
		faceDetectionData.data?.map((value, index) => {
			let checkSize = value.BoundingBox.Width * value.BoundingBox.Height;
			if (checkSize > biggestFaceSize) {
				biggestFaceSize = checkSize;
				tempImageIdx = index;
				console.log('getBirthday tempImageIdx', tempImageIdx, value);
			}
		});
		/**
		 * 선택한 얼굴 부분의 x축, z축 회전이 제한한 값에 속하는지 체크해준다.
		 */
		console.log('getBirthday faceDetectionData', faceDetectionData);
		isLimit = true;

		let tempImageURL = '';
		if (isLimit) {
			if (typeof file === 'string') {
				tempImageURL = URL.createObjectURL(new Blob([file]), {
					type: 'image/png',
				});
			} else {
				tempImageURL = URL.createObjectURL(file);
			}
		}
		let cropResult = await editImage(
			tempImageURL,
			faceDetectionData?.data[tempImageIdx],
		);

		return cropResult;
	} catch (error) {
		console.error('getBirthday', error);
	}
};

export const getMetaverseFaceImageList = async (serial) => {
	const url = `/contents/metaverse/liku/${serial}/photos`;
	const result = await authApi.get(url);
	console.log('getMetaverseFaceImageList', result);
	return result;
};
